export default class {

  constructor ({
                 data,
                 label,
                 labels,
                 backgroundColor = 'rgba(0,0,0,0.3)',
                 borderColor = 'rgba(0,0,0,0.3)',
                 type = 'bar',
               }) {

    this.data = data,
    this.borderColor = borderColor
    this.type = type,
    this.backgroundColor = backgroundColor,
    this.label = label,
    this.labels = labels

  }
}



// WEBPACK FOOTER //
// ./src/common/chart/Component/BarChartDataset.js